<template>
    <v-container fluid class="display-flex">
        <v-flex xs12 md3 lg3 xl3 class="above pa-1 no-bottom-pad">
            <map-list-top-bar :import-file="toggleImportFileDialog" :add-route="createRouteProcess"
                              :add-task="toggleCreateTask" :reset-route-map="resetMap" :archive-outdated="toggleArchiveOutdated"></map-list-top-bar>
            <v-card flat>
                <v-tabs v-model="tab" grow show-arrows>
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab href="#tasks">Tasks</v-tab>
                    <v-tab href="#routes">Routes</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tasks">
                        <v-container grid-list-lg class="custom-grid-list" xs12>
                            <v-row>
                                <v-col sm="6">
                                    <v-dialog
                                        ref="selectStartDateDialog"
                                        v-model="selectStartDateDialog"
                                        :return-value.sync="taskMapStartDate"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                class="my-2 ml-2 date-pickers-height"
                                                outlined
                                                clearable
                                                v-model="taskMapStartDate"
                                                label="Start Date"
                                                prepend-icon="event"
                                                readonly
                                                dense
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="taskMapStartDate" scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="selectStartDateDialog = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.selectStartDateDialog.save(taskMapStartDate)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                                <v-col sm="6">
                                    <v-dialog
                                        ref="selectEndDateDialog"
                                        v-model="selectEndDateDialog"
                                        :return-value.sync="taskMapEndDate"
                                        persistent
                                        width="290px"
                                    >
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                class="my-2 pr-4 date-pickers-height"
                                                outlined
                                                clearable
                                                v-model="taskMapEndDate"
                                                label="End Date"
                                                readonly
                                                dense
                                                v-on="on"
                                            ></v-text-field>
                                        </template>
                                        <v-date-picker v-model="taskMapEndDate" scrollable color="primary">
                                            <v-spacer></v-spacer>
                                            <v-btn text color="primary" @click="selectEndDateDialog = false">Cancel</v-btn>
                                            <v-btn text color="primary" @click="$refs.selectEndDateDialog.save(taskMapEndDate)">OK</v-btn>
                                        </v-date-picker>
                                    </v-dialog>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col sm="12">
                                    <v-autocomplete
                                        v-model="routeIdForPlanning"
                                        :items="routes"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        :disabled="planningModeActive"
                                        :clearable="!planningModeActive"
                                        dense
                                        hide-details
                                        placeholder="Select Route"
                                        label="Select Route"
                                    ></v-autocomplete>
                                </v-col>
                            </v-row>
                            <v-row v-if="planningModeActive">
                                <v-col sm="6">
                                    <v-btn mx-2
                                           color="accent"
                                           :dark="numberOfTasksPlanned !== 0"
                                           depressed
                                           block
                                           :disabled="numberOfTasksPlanned === 0"
                                           @click="savePlanning">Save
                                    </v-btn>
                                </v-col>
                                <v-col sm="6">
                                    <v-btn mx-2 color="danger" dark depressed block @click="toggleInteractivePlanning">Cancel</v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-else>
                                <v-col sm="12">
                                    <v-btn mx-2 color="accent" :dark="routeIdForPlanning != null" depressed block :disabled="routeIdForPlanning == null" @click="toggleInteractivePlanning">Plan selected route</v-btn>
                                </v-col>
                            </v-row>
                            <v-row wrap class="custom-row-layout-tasks" id="scroll-target">
                                <v-col xs12 v-scroll:#scroll-target="onScroll">
                                    <task-list :updateTaskList="updateTaskList"> </task-list>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item value="routes">
                        <v-container grid-list-lg class="custom-grid-list" xs12>
                            <v-row wrap class="custom-row-layout-routes">
                                <v-col xs12>
                                    <route-list :edit-route-process="openRouteDetails"></route-list>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-flex>
        <v-flex xs12 md9 class="above pa-1 no-bottom-pad">
            <task-map-view
                :tab="tab" v-bind:class="tab === 'tasks' ? 'hideMap' : 'showMap'"
                :updateTaskList="updateTaskList"
                :planningModeActive="planningModeActive"
                :assignTaskCallback="addTaskById"
                :selectedTasks="taskIdsForPlanning"
            ></task-map-view>
            <route-map-view :tab="tab" v-bind:class="tab === 'routes' ? 'hideMap' : 'showMap'"></route-map-view>
        </v-flex>
        <task-add :toggle="toggleCreateTask" :show-dialog="createTaskDialog"></task-add>
        <archive-route :toggle="toggleArchive" :show-dialog="archiveDialog" :route="selectedRoute"
                       :incompleteTasks="incompleteTasks"></archive-route>
        <route-details
            :action-type="detailsType"
            v-if="!taskDetailsDialog"
            :toggle="toggleRouteDetails" :show-dialog="routeDetails"
            :show-remove-task-dialog="removeTaskFromRoute"
            :show-task-details-dialog="editTaskDetails"
            :show-remove-user-dialog="removeUserFromTask">
        </route-details>
        <task-details v-if="taskDetailsDialog" :job-task="selectedDetailsTask" :show-dialog="taskDetailsDialog" :toggle="toggleTaskDetailsDialog"></task-details>
        <unassign-task :show-dialog="removeTaskDialog" :toggle="toggleRemoveTaskDialog" :job-task="selectedDetailsTask"></unassign-task>
        <remove-user-from-task :show-dialog="removeUserDialog" :toggle="toggleRemoveUserDialog"
                               :user="selectedUser"></remove-user-from-task>
        <import-file-dialog :show-dialog="importFileDialog" :toggle="toggleImportFileDialog"></import-file-dialog>
        <archive-outdated :show-dialog="archiveOutdatedDialog" :toggle="toggleArchiveOutdated"></archive-outdated>

    </v-container>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import TaskList from '../../components/jobTasks/TaskList'
    import TaskMapView from '../../components/jobTasks/TaskMapView'
    import TaskAdd from '../../components/jobTasks/Add'
    import RouteList from '../../components/routes/RouteList'
    import RouteMapView from '../../components/routes/RouteMapView'
    import RouteDetails from '../../components/routes/Details'
    import ArchiveRoute from '../../components/routes/Archive'
    import UnassignTask from '../../components/jobTasks/UnassignTask'
    import RemoveUserFromTask from '../../components/users/RemoveUserFromTask';
    import ImportFileDialog from "../../components/files/Import";
    import ArchiveOutdated from  '../../components/jobTasks/ArchiveOutdated'
    import MapListTopBar from '../../components/_layouts/MapListTopBar'
    import TaskDetails from '../../components/jobTasks/Details'
    export default {
        name: 'jobTasks',
        data() {
            return {
                tab: 'tasks',
                selectStartDateDialog: false,
                selectEndDateDialog: false,
                createTaskDialog: false,
                createRouteDialog: false,
                archiveDialog: false,
                routeDetails: false,
                removeTaskDialog: false,
                removeUserDialog: false,
                importFileDialog: false,
                planningModeActive: false,
                selectedUser: null,
                routeIdForPlanning: null,
                taskIdsForPlanning: new Set(),
                numberOfTasksPlanned: 0,
                routeForDetails: null,
                selectedDetailsTask: null,
                taskDetailsDialog: false,
                detailsType: '',
                archiveOutdatedDialog: false,
                taskMapStartDate: null,
                taskMapEndDate: null,
                numListTasks: 20,
                currentScrollLimit: 0,
            }
        },
        created() {
            this.getMapTaskLocations({ startDate: null, endDate: null })
            this.loadAllRoutes()
            this.getActiveCount()
            this.getNumberAndAddress()
            this.getJobTaskRange({
                keywords: '',
                limit: 20,
                offset: 0,
                startDate: null,
                endDate: null
            })
        },
        components: {
            TaskAdd,
            TaskList,
            TaskMapView,
            RouteList,
            RouteMapView,
            RouteDetails,
            ArchiveRoute,
            UnassignTask,
            RemoveUserFromTask,
            MapListTopBar,
            ImportFileDialog,
            ArchiveOutdated,
            TaskDetails
        },
        methods: {
            ...mapActions({
                getMapTaskLocations: 'jobTasks/getMapTaskLocations',
                getTask: 'jobTasks/getById',
                loadAllRoutes: 'routes/getAll',
                loadAllRouteLocations: 'routes/getRouteAndLocations',
                getIsolatedRoute: 'routes/getIsolatedRoute',
                clearSelectedRoute: 'routes/clearSelectedRoute',
                selectRoute: 'routes/selectRoute',
                clearSelectedTask: 'jobTasks/clearSelected',
                getNumberAndAddress: 'jobTasks/getNumberAndAddress',
                getJobTaskRange: 'jobTasks/getActiveRange',
                getActiveCount: 'jobTasks/getActiveCount',
                assignTasksToRoute: 'routes/assignTasksToRoute'

            }),
            toggleCreateTask() {
                this.createTaskDialog = !(this.createTaskDialog)
            },
            async createRouteProcess() {
                await this.clearSelectedRoute()
                let letters = "0123456789ABCDEF";
                let color = '#';
                for (let i = 0; i < 6; i++)
                    color += letters[(Math.floor(Math.random() * 16))];

                let route = {
                    name: '',
                    id: null,
                    duration: '00:00:00',
                    color: color,
                    jobTasks: [],
                    userRoutes: []
                }
                this.detailsType = 'create'
                await this.selectRoute(route)
                this.toggleRouteDetails()
            },
            async removeTaskFromRoute(task) {
                this.selectedDetailsTask = task
                await this.toggleRemoveTaskDialog()
            },
            async removeUserFromTask(user) {
                this.selectedUser = user
                await this.toggleRemoveUserDialog()
            },
            toggleRemoveTaskDialog() {
                this.removeTaskDialog = !(this.removeTaskDialog)
            },
            async editTaskDetails (task) {
                this.selectedDetailsTask = task
                await this.toggleTaskDetailsDialog()
            },
            async toggleTaskDetailsDialog () {
                await this.toggleRouteDetails()
                this.taskDetailsDialog = !(this.taskDetailsDialog)
            },
            resetMap() {
                this.clearSelectedTask()
                this.loadAllRouteLocations()
            },
            async openRouteDetails(item) {
                await this.getIsolatedRoute(item.id)
                this.detailsType = 'update'
                await this.toggleRouteDetails()
            },
            async archiveRoute(route) {
                await this.selectRoute(route)
                await this.toggleArchive()
            },
            toggleArchive() {
                this.archiveDialog = !(this.archiveDialog)
            },
            toggleRouteDetails() {
                if(this.routeDetails){
                    this.updateTaskList()
                }
                this.routeDetails = !(this.routeDetails)
            },
            toggleRemoveUserDialog() {
                this.removeUserDialog = !(this.removeUserDialog)
            },
            toggleImportFileDialog() {
                this.importFileDialog = !(this.importFileDialog)
            },
            toggleArchiveOutdated() {
                if(this.archiveOutdatedDialog){
                    this.updateTaskList()
                }
                this.archiveOutdatedDialog = !(this.archiveOutdatedDialog)
            },
            toggleInteractivePlanning(){
                this.taskIdsForPlanning = new Set()
                this.numberOfTasksPlanned = 0
                this.planningModeActive = !this.planningModeActive
            },
            addTaskById(taskId){
                this.taskIdsForPlanning.add(taskId)
                this.numberOfTasksPlanned = this.taskIdsForPlanning.size
            },
            savePlanning(){
                this.assignTasksToRoute({ routeId: this.routeIdForPlanning, taskIds: Array.from(this.taskIdsForPlanning)})
                this.taskIdsForPlanning = new Set()
                this.numberOfTasksPlanned = 0
                this.planningModeActive = !this.planningModeActive
            },
            updateTaskList(){
                this.getJobTaskRange({
                    keywords: '',
                    limit: this.numListTasks,
                    offset: 0,
                    startDate: this.taskMapStartDate,
                    endDate: this.taskMapEndDate
                })
                this.getMapTaskLocations({ startDate: this.taskMapStartDate, endDate: this.taskMapEndDate});
            },
            onScroll ({ target: { scrollTop, clientHeight, scrollHeight } }) {
                const end = scrollHeight - clientHeight
                if(scrollTop > this.currentScrollLimit){
                    this.currentScrollLimit = scrollTop
                }
                //if we're 90% of the way down
                if (this.currentScrollLimit > Math.floor(end * 0.9)) {
                    //Add 20 the number loaded
                    if ((this.numListTasks + 20) > this.activeCount) {
                        this.numListTasks = this.activeCount
                    } else {
                        this.numListTasks += 20
                    }
                    //could implement a search feature with keywords
                        this.getJobTaskRange({
                            keywords: '',
                            limit: this.numListTasks,
                            offset: 0,
                            startDate: this.taskMapStartDate,
                            endDate: this.taskMapEndDate
                        })
                }
            }
        },
        computed: {
            ...mapGetters({
                routes: 'routes/routes',
                selectedRoute: 'routes/selectedRoute',
                incompleteTasks: 'routes/selectedRouteIncompleteTasks',
                headers: 'routes/headers',
                error: 'routes/error',
                listTasks: 'jobTasks/activeTaskRange',
                activeCount: 'jobTasks/activeCount',

            }),
        },
        watch: {
            taskMapStartDate: function () {
                this.updateTaskList();
            },
            taskMapEndDate: function () {
                this.updateTaskList();
            }
        }
    }
</script>

<style scoped>
    .no-bottom-pad {
        padding-bottom: 0;
        margin-bottom: 0;
    }

    .date-pickers-height {
        height: 40px;
    }

    .custom-row-layout-tasks {
        height: 70vh;
        overflow: auto;
        overflow-x: hidden;
    }
    .custom-row-layout-routes {
        height: 80vh;
        overflow: auto;
        overflow-x: hidden;
    }

    .custom-grid-list {
        margin: unset !important;
    }

    .display-flex {
        display: flex;
    }

    .showMap {
        visibility: hidden;
        position: absolute;
        top: -100px;
    }

    .hideMap {
        visibility: visible;
        position: relative;
        top: 0;
    }
</style>
